import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { FF_MEXICAN_BANNER } from 'constants/features';
import icon from 'icons/ico-info.svg';
import type { RootState } from 'reducers/types';
import { getFeature } from 'selectors/features/features';
import { getCurrentLocale, isPayingFromMexico } from 'selectors/ui/ui';
import { useTranslations } from 'utils';
import { createMarkup } from 'utils/createMarkup/createMarkup';

import './MexicanBanner.scss';

type PropsFromRedux = ConnectedProps<typeof connector>;
type MexicanBannerProps = PropsFromRedux & {
  locale: string;
};

const SPANISH_LOCALE = 'es-ES';
const SPANISH_URL = 'https://help.flywire.com/hc/es';
const DEFAULT_URL = 'https://help.flywire.com/hc/en-us';

const MexicanBannerComponent = ({
  featureEnabled,
  isPayingFromMexico,
  locale,
}: MexicanBannerProps) => {
  const i18n = useTranslations();

  if (!isPayingFromMexico || !featureEnabled) return null;

  const helpUrl = (locale: string) => {
    return locale === SPANISH_LOCALE ? SPANISH_URL : DEFAULT_URL;
  };

  return (
    <div className="MexicanBanner">
      <img className="MexicanBanner-icon" src={icon} alt="Mexican warn" />
      <h3 className="MexicanBanner-title">{i18n.t('mexicanBanner.title')}</h3>
      <p
        className="MexicanBanner-description"
        dangerouslySetInnerHTML={createMarkup(
          i18n.t('mexicanBanner.description', {
            url: helpUrl(locale),
          }),
        )}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  // @ts-expect-error feature flags are camelized
  featureEnabled: getFeature(state, FF_MEXICAN_BANNER),
  isPayingFromMexico: isPayingFromMexico(state),
  locale: getCurrentLocale(state),
});

const connector = connect(mapStateToProps);
const MexicanBanner = connector(MexicanBannerComponent);

export { MexicanBanner };
